/*
 * Copyright (c) 2022 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React from "react";

import {
  Table,
  ColHeader,
  TableBody,
  Col,
} from "src/components/tables/Table.react";
import Card from "src/components/cards/Card.react";
import ResultDropdown from "src/components/dropdowns/Result.react";
import BoltOptions from "src/components/dropdowns/Bolt.react";

/**
 * The SingleBolt component
 *
 * @author Thais Watanabe
 */
const SingleBolt = (props) => {
  const {
    activeTab,
    inspectionModelItems,
    openEdit,
    openObs,
    turbineInspection,
    selectedResult,
    lastTurbineInspections,
    inspection,
    openBoltEdit,
    boltToInspection
  } = props;

  return (
    <Card
      title={
        <>
          {`${activeTab.split("-")[1]} - ${
            inspectionModelItems.find((obj) => obj.name === activeTab)
              .description
          }`}
          <ResultDropdown
            openEdit={openEdit}
            openObs={openObs}
            turbineInspection={turbineInspection}
            selectedItem={inspectionModelItems.find(
              (obj) => obj.name === activeTab
            )}
            selectedResult={selectedResult}
            lastTurbineInspections={lastTurbineInspections}
            inspection={inspection}
          />
        </>
      }
    >
      <div className="grid gap-x-4 grid-cols-3 print:gap-x-2">
        {activeTab.split("-")[1] < 16 && (
          <Table>
            <thead>
              <tr>
                <ColHeader colSpan={3}>写真撮影</ColHeader>
              </tr>
            </thead>
            <TableBody>
              <tr>
                <ColHeader className="w-40">圧力確認</ColHeader>
                <Col>{selectedResult?.childrenResults?.[2]}</Col>
              </tr>
              <tr>
                <ColHeader>締め付け確認</ColHeader>
                <Col>{selectedResult?.childrenResults?.[3]}</Col>
              </tr>
              <tr>
                <ColHeader>ハンマ確認</ColHeader>
                <Col>{selectedResult?.childrenResults?.[5]}</Col>
              </tr>
              <tr>
                <ColHeader>作業後確認</ColHeader>
                <Col>{selectedResult?.childrenResults?.[11]}</Col>
              </tr>
            </TableBody>
          </Table>
        )}

        <div>
          <Table className="mb-2">
            <thead>
              <tr>
                <ColHeader colSpan={2}>トルク・ハンマ確認</ColHeader>
              </tr>
            </thead>
            <TableBody>
              <tr>
                <ColHeader className="w-24">点検日</ColHeader>
                <Col>{selectedResult?.childrenResults?.[0]}</Col>
              </tr>
              <tr>
                <ColHeader>点検者</ColHeader>
                <Col>{selectedResult?.childrenResults?.[1]}</Col>
              </tr>
            </TableBody>
          </Table>

          <Table>
            <thead>
              <tr>
                <ColHeader colSpan={2}>新規 合マーク</ColHeader>
              </tr>
            </thead>
            <TableBody>
              <tr>
                <ColHeader className="w-24">色</ColHeader>
                <Col>
                  {activeTab.split("-")[1] < 16
                    ? selectedResult?.childrenResults?.[4]
                    : selectedResult?.childrenResults?.[2]}
                </Col>
              </tr>
            </TableBody>
          </Table>
        </div>
        {activeTab.split("-")[1] < 16 && (
          <div>
            <Table className="mb-2">
              <thead>
                <tr>
                  <ColHeader colSpan={2}>レンチ</ColHeader>
                </tr>
              </thead>
              <TableBody>
                <tr>
                  <ColHeader className="w-24">型式番号</ColHeader>
                  <Col>{selectedResult?.childrenResults?.[6]}</Col>
                </tr>
                <tr>
                  <ColHeader>管理番号</ColHeader>
                  <Col>{selectedResult?.childrenResults?.[7]}</Col>
                </tr>
              </TableBody>
            </Table>

            <Table>
              <thead>
                <tr>
                  <ColHeader colSpan={2}>ポンプ</ColHeader>
                </tr>
              </thead>
              <TableBody>
                <tr>
                  <ColHeader className="w-24">型式番号</ColHeader>
                  <Col>{selectedResult?.childrenResults?.[8]}</Col>
                </tr>
                <tr>
                  <ColHeader>管理番号</ColHeader>
                  <Col>{selectedResult?.childrenResults?.[9]}</Col>
                </tr>
              </TableBody>
            </Table>
          </div>
        )}
      </div>

      <Table className="mt-10 print:mt-2">
        <thead>
          <tr>
            <ColHeader className="text-center w-10 print:hidden" rowSpan={2}>
              <BoltOptions
                openBoltEdit={openBoltEdit}
                turbineInspection={turbineInspection}
                selectedItem={inspectionModelItems.find(
                  (obj) => obj.name === activeTab
                )}
                selectedResult={selectedResult}
              />
            </ColHeader>
            <ColHeader className="text-center" colSpan={3}>
              ボルト点検表
            </ColHeader>
          </tr>
          <tr>
            <ColHeader className="text-center">ボルト No.</ColHeader>
            <ColHeader className="text-center">合マークズレ</ColHeader>
            <ColHeader className="text-center">回転角度</ColHeader>
          </tr>
        </thead>
        <TableBody>
          {selectedResult?.customResults?.map((result, i) => (
            <tr
              key={i}
              className={`${
                boltToInspection?.includes(i + 1) && "bg-teal-50"
              } text-center`}
            >
              <Col className=" print:hidden"></Col>
              <Col>{parseInt(result.split(",")[0])}</Col>
              <Col>{result.split(",")[1]}</Col>
              <Col>{result.split(",")[2]} º</Col>
            </tr>
          ))}
        </TableBody>
      </Table>
    </Card>
  );
};

export default SingleBolt;
